class healthlegal {
    constructor() {
      this.items = [
        {
          id: 197,
          name: "Daily Plan Basic",
          badge: "Basic",
          coverage: "300,000",
          price:"3",
          bgColorClass: "bg-info",
          description: `<p>Quick Online Enrolment: Secure your family&rsquo;s future with easy online sign-up for accidental life insurance.</p>
<ul>
<li><strong>Coverage Amount:</strong> Up to Rs. 300,000 for accidental life insurance</li>
<li><strong>Insurance Period:</strong> 30 days</li>
<li><strong>Subscription:</strong> Daily</li>
</ul>
<p><strong>Seamless Claims Process:&nbsp;</strong>Experience fast and straightforward claims processing through our friendly support team.</p>`,
          type: "insurance",
        },
        {
          id: 198,
          name: "Daily Plan Silver",
          badge: "Silver",
          coverage: "600,000",
          price:"6",
          bgColorClass: "bg-warning",
          description: `<p>Quick Online Enrolment: Secure your family&rsquo;s future with easy online sign-up for accidental life insurance.</p>
<ul>
<li><strong>Coverage Amount:</strong> Up to Rs. 600,000 for accidental life insurance</li>
<li><strong>Insurance Period:</strong> 30 days</li>
<li><strong>Subscription:</strong> Daily</li>
</ul>
<p><strong>Seamless Claims Process:</strong>&nbsp;Experience fast and straightforward claims processing through our friendly support team.</p>`,
          type: "insurance",
        },
        {
          id: 199,
          name: "Daily Plan Gold",
          badge: "Gold",
          coverage: "1,000,000",
          price:"12",
          bgColorClass: "bg-info",
          description: `<p>Quick Online Enrolment: Secure your family&rsquo;s future with easy online sign-up for accidental life insurance.</p>
<ul>
<li><strong>Coverage Amount:</strong> Up to Rs. 1,000,000 for accidental life insurance</li>
<li><strong>Insurance Period:</strong> 30 days</li>
<li><strong>Subscription:</strong> Daily</li>
</ul>
<p><strong>Seamless Claims Process:</strong> Experience fast and straightforward claims processing through our friendly support team.</p>`,
          type: "insurance",
        }
      ];
    }
  
    getAllItems() {
      return this.items;
    }
  }
  
  export default healthlegal;
  